import { render, staticRenderFns } from "./ModalSuccessPayment.vue?vue&type=template&id=b7f0f068&"
import script from "./ModalSuccessPayment.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports